import type { ReactNode } from 'react';
import { Plus } from 'lucide-react';
import { AssetMarketplace } from '../../../components/marketplace';
import type { MarketplaceAsset } from '../../../types/marketplace';

export interface SkillPanelProps {
  assets: MarketplaceAsset[];
  /** 启用 / 禁用技能。 */
  onToggle: (asset: MarketplaceAsset) => void;
  /** 「说人话搜索」：本地 Skill 路由器相关度排序（失败由市场回退本地过滤）。 */
  onSearchRoute?: (term: string) => Promise<string[] | null>;
  /** 设为全局（高信任档位）；无权限时不传。 */
  onSetGlobal?: (asset: MarketplaceAsset) => void;
  /** 点击编辑：页面按 id 找到技能并打开编辑器。 */
  onEdit: (asset: MarketplaceAsset) => void;
  /** 新增技能。 */
  onAdd: () => void;
  /** 技能在线服务工具栏节点。 */
  toolbar: ReactNode;
}

/** 技能维度面板：技能橱窗（启用 / 禁用 / 搜索路由 / 信任提升 / 新增编辑）。 */
export default function SkillPanel({ assets, onToggle, onSearchRoute, onSetGlobal, onEdit, onAdd, toolbar }: SkillPanelProps) {
  return (
    <div>
      <div className="flex items-center justify-between mb-3">
        <h3 style={{ margin: 0 }}>技能橱窗</h3>
        <button className="primary" style={{ padding: '6px 12px', fontSize: 13 }} onClick={onAdd}>
          <Plus size={14} /> 新增技能
        </button>
      </div>
      {toolbar}
      <AssetMarketplace
        assets={assets}
        initialType="skill"
        hideTypeFilter
        title=""
        applyLabel="启用"
        removeLabel="禁用"
        onToggle={onToggle}
        onSearchRoute={onSearchRoute}
        onSetGlobal={onSetGlobal}
        onEdit={onEdit}
      />
    </div>
  );
}
